import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faClock, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faVk, faTelegram, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';

const FooterContainer = styled.footer`
  background-color: #1a1a1a;
  color: white;
  padding: var(--spacing-xl) 0 var(--spacing-md);
`;

const FooterContent = styled.div`
  max-width: var(--container-width);
  padding: 0 var(--container-padding);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-xl);
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div``;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  color: white;
  margin-bottom: var(--spacing-lg);
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 2px;
    background-color: var(--color-secondary);
  }
`;

const FooterNav = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterNavItem = styled.li`
  margin-bottom: var(--spacing-sm);
`;

const FooterLink = styled.a`
  color: #cccccc;
  text-decoration: none;
  transition: color var(--transition-fast);
  font-size: 0.95rem;
  
  &:hover {
    color: var(--color-secondary);
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-md);
  
  svg {
    width: 16px;
    margin-right: var(--spacing-sm);
    color: var(--color-secondary);
  }
`;

const ContactText = styled.p`
  margin: 0;
  color: #cccccc;
  font-size: 0.95rem;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: var(--spacing-sm);
  margin-top: var(--spacing-md);
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #333;
  border-radius: 50%;
  color: white;
  transition: all var(--transition-normal);
  
  &:hover {
    background-color: var(--color-secondary);
    transform: translateY(-3px);
  }
`;

const Logo = styled.a`
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  text-decoration: none;
  margin-bottom: var(--spacing-md);
  display: block;
  
  span {
    color: var(--color-secondary);
  }
`;

const LogoText = styled.p`
  color: #cccccc;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: var(--spacing-md);
`;

const FooterBottom = styled.div`
  max-width: var(--container-width);
  padding: var(--spacing-md) var(--container-padding) 0;
  margin: 0 auto;
  border-top: 1px solid #333;
  margin-top: var(--spacing-xl);
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: #777;
  font-size: 0.9rem;
  margin: 0;
  
  @media (max-width: 768px) {
    margin-bottom: var(--spacing-sm);
  }
`;

const Policy = styled.div`
  display: flex;
  gap: var(--spacing-lg);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: var(--spacing-xs);
  }
`;

const PolicyLink = styled.a`
  color: #777;
  font-size: 0.9rem;
  text-decoration: none;
  
  &:hover {
    color: var(--color-secondary);
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <Logo href="#home">Купить-<span>Стрейч.РФ</span></Logo>
          <LogoText>
            Лидер на рынке стрейч-пленки с 2015 года. Мы поставляем продукцию для бизнеса и частных клиентов, гарантируя качество и быструю доставку.
          </LogoText>
          <SocialIcons>
            <SocialIcon href="https://vk.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faVk} />
            </SocialIcon>
            <SocialIcon href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </SocialIcon>
            <SocialIcon href="https://t.me/kupitstreych" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTelegram} />
            </SocialIcon>
            <SocialIcon href="https://wa.me/74951339612" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faWhatsapp} />
            </SocialIcon>
          </SocialIcons>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Навигация</FooterTitle>
          <FooterNav>
            <FooterNavItem>
              <FooterLink href="#home">Главная</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#catalog">Каталог</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#calculator">Калькулятор Опта</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#about">О нас</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#partnership">Партнерство</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#reviews">Отзывы</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#contacts">Контакты</FooterLink>
            </FooterNavItem>
          </FooterNav>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Услуги</FooterTitle>
          <FooterNav>
            <FooterNavItem>
              <FooterLink href="#catalog">Стрейч-пленка оптом</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#catalog">Стрейч-пленка в розницу</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#calculator">Расчет стоимости опта</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#partnership">Сотрудничество с заводами</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#contacts">Доставка</FooterLink>
            </FooterNavItem>
            <FooterNavItem>
              <FooterLink href="#contacts">Консультация специалиста</FooterLink>
            </FooterNavItem>
          </FooterNav>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle>Контакты</FooterTitle>
          <ContactItem>
            <FontAwesomeIcon icon={faPhone} />
            <ContactText>+7 (495) 133-96-12</ContactText>
          </ContactItem>
          <ContactItem>
            <FontAwesomeIcon icon={faEnvelope} />
            <ContactText>info@купить-стрейч.рф</ContactText>
          </ContactItem>
          <ContactItem>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            <ContactText>г. Москва, ул. Складская, д. 5</ContactText>
          </ContactItem>
          <ContactItem>
            <FontAwesomeIcon icon={faClock} />
            <ContactText>Пн–Пт: 9:00–18:00, Сб–Вс: выходной</ContactText>
          </ContactItem>
        </FooterColumn>
      </FooterContent>
      
      <FooterBottom>
        <Copyright>© 2023 Купить-Стрейч.РФ. Все права защищены.</Copyright>
        <Policy>
          <PolicyLink href="#">Политика конфиденциальности</PolicyLink>
          <PolicyLink href="#">Пользовательское соглашение</PolicyLink>
        </Policy>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer; 